import SearchDropdown from '@/components/component/admin/SearchDropdown/SearchDropdown.vue'
import {isEmpty} from 'lodash'
import  constants from '@/libs/constant/constants'
import { message} from '@/libs/helper'
import {bulkUpdate} from '@/libs/api/api'


export default {
    name: 'ReplaceMeta',
    components: {SearchDropdown},
    props: {
        module: {
            type: String
        },
        metaData: {
            type: Object
        },
        buttonAction: {
            type: Function
        }
    },
    data() {
        return {
            isFinal: false,
            isConfirm: false,
            step: 1,
            isEmpty,
            skip: 0,
            isProgress: false,
            metaConfirmed: true,
            metaChecked: false,
            action: '',
            actionValue: '',
            selectedMetaData: {}
        }
    },
    methods: {
        handleSearch (type, item) {
            this.selectedMetaData = item
        },
        button (type) {
            switch (type) {
                case 'next': 
                    this.isConfirm = true
                    this.step = 2
                break
                case 'back':
                    this.isConfirm = false
                    this.step = 1
                break
                case 'confirm':
                    if (this.module === 'AUTHOR' || this.module === 'PUBLICATION' || this.module === 'PUBLISHER') {
                        this.replaceMetaData()
                    }
                break
            }
        },
        changeAction (action) {
            this.actionValue = constants.REPLACE_META[action].value 
        },
        isDisabled () {
            if (this.metaChecked && !isEmpty(this.selectedMetaData) && this.action !== '') return false
            return true
        },
        replaceMetaData: async function () { 
           try {
                if (this.action === '' || isEmpty(this.selectedMetaData)) {
                    message(this, constants.messageType.ERROR, "Some fields are missing")
                    return
                }
                if (this.selectedMetaData._id === this.metaData._id) {
                    message(this, constants.messageType.ERROR, `Same ${this.module} should not be selected`)
                    return
                }
                this.skip = 15
                this.isProgress = true
                let body = await this.getBody(this.module)
                await bulkUpdate(this.module.toLowerCase(), body)
                this.skip = 100 
                this.isProgress = false
                this.step = 3
                this.isFinal = true
           } catch (error) {
                console.error(error)
                this.isProgress = false
           }
            
        },
        getBody (module) {
            let body = {
                entity_ids: [this.metaData._id] 
            }
            switch (module) {
                case 'AUTHOR': 
                    body.replace = {
                        action: this.action,
                        author_id: this.selectedMetaData._id
                    }
                break
                case 'PUBLICATION': 
                    body.replace = {
                        action: this.action,
                        publication_id: this.selectedMetaData._id
                    }
                break
                case 'PUBLISHER': 
                    body.replace = {
                        action: this.action,
                        publisher_id: this.selectedMetaData._id
                    }
                break
            }
            return body
        }
    }
}